import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { MaterialModule } from '../../../app.module';
import { SharedModule } from '../../shared.module';

import { TablasComponent } from './tablas.component';
import { GreetingSelectorComponent } from './greeting-selector.component';
import { PiComponent } from './views/processing-instructions/pi/pi.component';
import { MyleadsComponent } from './views/clients/myleads/myleads.component';
import { ListItemsComponent } from './locations/list-items/list-items.component';
import { InternallocationsComponent } from './locations/internallocations/internallocations.component';
import { ListScrapsComponent } from './locations/list-scraps/list-scraps.component';
import { ProposalComponent } from './views/proposal/proposal.component';
import { ContainerComponent } from './views/container/container.component';
import { ScrapsComponent } from './views/scraps/scraps.component';
import { TicketsComponent } from './views/tickets/tickets.component';
import { ProgressComponent } from './views/scraps/progress/progress.component';
import { CompletedComponent } from './views/scraps/completed/completed.component';
import { ShippedComponent } from './views/scraps/shipped/shipped.component';
import { VirtualContainerComponent } from './views/virtual-container/virtual-container.component';

@NgModule({
  declarations: [
    TablasComponent,
    GreetingSelectorComponent,
    PiComponent,
    MyleadsComponent,
    ListItemsComponent,
    InternallocationsComponent,
    ListScrapsComponent,
    ProposalComponent,
    ContainerComponent,
    ScrapsComponent,
    TicketsComponent,
    ProgressComponent,
    CompletedComponent,
    ShippedComponent,
    VirtualContainerComponent
  ],
  imports: [
  SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule
  ], exports: [ TablasComponent ]
})
export class TablasModule { }
